// File: utils/consentChannels.js
// Fallback channel metadata for the consent nodes. The live list now comes from
// /channel/list via useConsentChannels — this stays as the offline fallback and as the
// icon source, since the API returns no icons.
// Channel ids are the platform-wide channel ids also used by the Message node.
import { FiMessageSquare, FiMail, FiBell, FiPhone, FiSmartphone } from 'react-icons/fi';
import { BsWhatsapp } from 'react-icons/bs';

export const CONSENT_CHANNELS = [
    { id: '1', label: 'SMS', icon: FiMessageSquare },
    { id: '2', label: 'WhatsApp', icon: BsWhatsapp },
    { id: '3', label: 'E-Mail', icon: FiMail },
    { id: '4', label: 'Voice (IVR)', icon: FiPhone },
    { id: '5', label: 'In-App Notification', icon: FiSmartphone },
    { id: '6', label: 'Push Notification', icon: FiBell },
];

export const getConsentChannel = (channelId) =>
    CONSENT_CHANNELS.find((c) => String(c.id) === String(channelId)) || null;

// CONSENT_MESSAGE_TYPES / getConsentMessageType removed: consent is per channel, not
// per message type, so the nodes no longer ask for (or send) one.
